"use client";

import { MessengerVisitorLauncher } from "@/app/(dashboard)/_components/messenger/messenger-launcher";
import type { ReactElement } from "react";
import { useHelpChrome } from "./help-chrome-context";

/** Bubble with the visitor messenger; „KI fragen“ opens it with the question. */
export function HelpCustomerChat({
  orgSlug,
  orgName,
}: {
  readonly orgSlug: string;
  readonly orgName: string;
}): ReactElement | null {
  const { askRequest, clearAsk, setChatAvailable } = useHelpChrome();
  return (
    <MessengerVisitorLauncher
      orgSlug={orgSlug}
      orgName={orgName}
      askRequest={askRequest}
      onAskHandled={clearAsk}
      onAvailability={setChatAvailable}
    />
  );
}
